/**
 * 时间类型 1:累計 2:今日 3: 昨日
 */
export var DateType;
(function (DateType) {
    DateType[DateType["Type1"] = 1] = "Type1";
    DateType[DateType["Type2"] = 2] = "Type2";
    DateType[DateType["Type3"] = 3] = "Type3";
})(DateType || (DateType = {}));
/**
 * 地图类型
 */
export var MapType;
(function (MapType) {
    MapType[MapType["Type1"] = 1] = "Type1";
    MapType[MapType["Type2"] = 2] = "Type2";
})(MapType || (MapType = {}));
